export const clearRemoteIndexedDB = () => {
  window.indexedDB?.deleteDatabase('firebase_remote_config');
};
